import React from 'react';
import { Box, Typography, Grid, Card, CardContent, Button, Chip, Stack } from '@mui/material';
import KitchenIcon from '@mui/icons-material/Kitchen';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

export const tips = [
  {
    title: 'Clean as You Cook',
    description: 'Wipe down counters and wash utensils as you prepare meals to prevent messes from piling up.',
  },
  {
    title: 'Shine Your Sink Nightly',
    description: 'After dinner, scrub your sink with baking soda and rinse with hot water. Finish with a splash of vinegar for a sparkling, odor-free sink.',
  },
  {
    title: 'Degrease Stove Tops Easily',
    description: 'Spray a mixture of equal parts vinegar and water on your stove top. Let it sit for 5 minutes, then wipe away grease with a microfiber cloth.',
  },
  {
    title: 'Pro Tip: Microwave Steam Clean',
    description: 'Place a bowl of water with lemon slices in the microwave and heat for 3 minutes. The steam loosens grime—just wipe clean!',
    pro: true,
  },
  {
    title: 'Organize Your Fridge Weekly',
    description: 'Toss expired items and wipe shelves with a mild soap solution every week to keep your fridge fresh and safe.',
  },
  {
    title: 'Disinfect High-Touch Handles',
    description: "Don't forget to regularly disinfect cabinet handles, appliance buttons, and light switches in your kitchen.",
  },{
    title: 'Garbage-Disposal Spa',
    description: 'Once a week, grind ice cubes with a handful of coarse salt to dislodge grit, then feed in citrus peels and run hot water for a fresh-smelling, sharp-bladed disposal.',
  },
  {
    title: 'Hidden Grease Traps',
    description: 'Slide a flexible cleaning wand (with microfiber cover) behind your range and fridge monthly to capture grease that settles where you can’t see it.',
  },
  {
    title: 'Range-Hood Filter TLC',
    description: 'Soak metal hood filters in hot water mixed with dish soap + baking soda for 30 min. Rinse and air-dry—restores airflow and cuts fire risk.',
  },
  {
    title: 'Enzymatic Cutting-Board Rescue',
    description: 'After washing wood boards, apply a paste of coarse salt and lemon juice. Let sit 5 min, then rinse. The enzymes break down odor-causing residues naturally.',
  },
  {
    title: 'Refrigerator Drain-Pan Refresh',
    description: 'Locate the drip tray beneath your fridge, remove, wash with hot soapy water plus a splash of bleach, then dry and replace. Prevents moldy puddles.',
  },
  {
    title: 'Coffee Maker Deep-Descale',
    description: 'Run a cycle with equal parts white vinegar and water once a month, then two plain-water cycles. Your machine lasts longer and coffee tastes purer.',
  },
  {
    title: 'Crevice-Clean Silicone Mats',
    description: 'Toss silicone baking mats into the dishwasher monthly, and scrub edges with an old toothbrush to remove hardened oil.',
  }
];

const KitchenTips = () => (
  <Box sx={{ mb: 6 }}>
    <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
      <KitchenIcon color="primary" sx={{ fontSize: 40 }} />
      <Typography variant="h4" fontWeight={700}>
        Kitchen Cleaning Tips
      </Typography>
    </Stack>
    <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 4 }}>
      Keep your kitchen sparkling with these expert tips!
    </Typography>
    <Grid container spacing={3}>
      {tips.map((tip, idx) => (
        <Grid item xs={12} sm={6} md={4} key={idx}>
          <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 1 }}>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="h6" fontWeight={600} sx={{ flexGrow: 1 }}>
                  {tip.title}
                </Typography>
                {tip.pro && (
                  <Chip icon={<EmojiObjectsIcon />} label="Pro Tip" color="warning" size="small" />
                )}
              </Stack>
              <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
                {tip.description}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Button variant="contained" color="primary" size="large">
        See all kitchen tips
      </Button>
    </Box>
  </Box>
);

export default KitchenTips; 